export default __webpack_public_path__ + "static/media/Banner_Top_03.4ede950b.jpg";